// SCR-015's Proposal card: the agent's typed `propose_install_config` call, read from the
// transcript (there is no dedicated endpoint — the proposal lives only in the session's messages,
// ERD §3.7). Every value is customer- or model-sourced and rendered as plain text (`latestProposal`
// already ran it through `visibleText`). A field whose choice needs explaining (the billing
// identity) carries its help topic beside the label.
import { Card, HelpButton } from "@nexus/ui";
import { latestProposal, type InstallerMessage } from "./model";

export function Proposal({ messages }: { messages: readonly InstallerMessage[] }) {
  const proposal = latestProposal(messages);
  return (
    <Card title="Proposal" titleId="proposal-heading" help="installer.proposal" class="proposal-card">
      {!proposal ? (
        <p class="muted">No configuration proposed yet.</p>
      ) : (
        <dl class="proposal-fields">
          {proposal.fields.map((field) => (
            <div class="proposal-field" key={field.label}>
              <dt>
                {field.label}
                {field.help && <HelpButton topic={field.help} label={field.label} />}
              </dt>
              <dd>
                <code>{field.value}</code>
              </dd>
            </div>
          ))}
        </dl>
      )}
    </Card>
  );
}
